module.exports = __webpack_public_path__ + "static/media/save.66469f6c.svg";